var _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpotlightInverse = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.3033C0 2.37437 2.37437 0 5.3033 0C6.70982 0 8.05874 0.558739 9.0533 1.5533L32 24.5H0V5.3033Z",
    fill: "url(#paint0_linear_7652_9977)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.47884 7.20703H10.5205V9.79036H9.47884V7.20703ZM12.9615 10.7958L14.7881 8.96973L15.5245 9.70618L13.698 11.5327L12.9615 10.7958ZM14.7079 13.9779H17.2913V15.0195H14.7079V13.9779ZM12.9648 18.199L13.7012 17.4626L15.5278 19.2891L14.7913 20.0251L12.9648 18.199ZM9.47884 19.2074H10.5205V21.7907H9.47884V19.2074ZM4.47681 19.2908L6.30389 17.4642L7.04035 18.2007L5.21379 20.0272L4.47681 19.2908ZM2.70801 13.9779H5.29134V15.0195H2.70801V13.9779ZM4.47355 9.70781L5.21053 8.97135L7.03709 10.7979L6.30063 11.5344L4.47355 9.70781ZM9.99967 12.4154C11.1503 12.4154 12.083 13.3481 12.083 14.4987C12.083 15.6493 11.1503 16.582 9.99967 16.582C8.84908 16.582 7.91634 15.6493 7.91634 14.4987C7.91634 13.3481 8.84908 12.4154 9.99967 12.4154V12.4154ZM9.99967 11.3737C8.27378 11.3737 6.87467 12.7728 6.87467 14.4987C6.87467 16.2246 8.27378 17.6237 9.99967 17.6237C11.7256 17.6237 13.1247 16.2246 13.1247 14.4987C13.1247 12.7728 11.7256 11.3737 9.99967 11.3737Z",
    fill: "#161616"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7652_9977",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186855,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AE58",
    stopOpacity: 0
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpotlightInverse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spotlight-inverse.058768bbfb0b9ee5f92509212431c4a3.svg";